import React, { useState, useEffect } from "react";
import TransactionsHome from "./transactionHome";
import { backendGetRequest, backendGetCached, backendUpdateCache, backendGetRequestWithCache } from "../../../helpers/callBackend";
import { documentTitle } from "../../../components/header/documentTitle";
import OuterBox from "../../../components/generic/arpariBoxes/OuterBox";


const Transactions = () => {
    const [generalLedgerHeader, setGeneralLedgerHeader] = useState([]); // eslint-disable-line no-unused-vars
    const [generalLedgerAccount, setGeneralLedgerAccount] = useState([]); // eslint-disable-line no-unused-vars

    const [transactionDataRaw, setTransactionDataRaw] = useState([]);
    const [nonCachedPagesTotal, setNonCachedPagesTotal] = useState(0)
    const [nonCachedPagesTotalRetrieved, setNonCachedPagesTotalRetrieved] = useState(0)
    const [refreshCallsTotal, setRefreshCallsTotal] = useState(0)
    const [refreshCallsTotalRetrieved, setRefreshCallsTotalRetrieved] = useState(0)

    const [allAccounts, setAllAccounts] = useState({});
    const [accountsLoading, setAccountsLoading] = useState(false);
    const [accountsPerPage, setAccountsPerPage] = useState({});
    const [accountsPageCountExpected, setAccountsPageCountExpected] = useState(0);
    const [accountsPageCountReceived, setAccountsPageCountReceived] = useState(-1);


    const [customCategories, setCustomeCategories] = useState([]);
    const [loadingRefresh, setLoadingRefresh] = useState(true); // eslint-disable-line no-unused-vars

    const [loadingCustomCategories, setLoadingCustomCategories] = useState(true); // eslint-disable-line no-unused-vars

    const [totalRecordsTransactions, setTotalRecordsTransactions] = useState(-1);
    const [customCategoriesRecordsCount, setCustomCategoriesRecordsCount] = useState(-1); // eslint-disable-line no-unused-vars
    const [customCategoriesPageCount, setCustomCategoriesPageCount] = useState(-1); // eslint-disable-line no-unused-vars
    const [transactionsLoading, setTransactionsLoading] = useState(true);

    const [customHierarchyPageCount, setCustomHierarchyPageCount] = useState(-1);
    const [customHierarchyRecordsCount, setCustomHierarchyRecordsCount] = useState(-1);
    const [loadingCustomHierarchy, setLoadingCustomHierarchy] = useState(-1);
    const [customHierarchy, setCustomHierarchy] = useState([]);

    const todayDate = new Date();
    let [currentMonth, setCurrentMonth] = useState(todayDate.getMonth() + 1);
    let [currentYear, setCurrentYear] = useState(todayDate.getFullYear());

    const BA_TAG = 1;
    const TXN_TAG = 2;

    useEffect(() => {
        documentTitle();
    }, []);

    useEffect(() => {
        if (!accountsPageCountExpected) return;
        setAccountsLoading(accountsPageCountExpected > accountsPageCountReceived);
    }, [accountsPageCountExpected, accountsPageCountReceived]);
    useEffect(() => {
        if (accountsPerPage && typeof accountsPerPage === 'object') {
            const newAllAccounts = Object.values(accountsPerPage).flat();
            setAllAccounts(newAllAccounts);
        }
    }, [accountsPerPage]);

    const getBankAccounts = () => {
        setAllAccounts([])
        setAccountsLoading(true)
        setAccountsPerPage({})
        setAccountsPageCountExpected(0)
        setAccountsPageCountReceived(-1)
        const baseParams = {}
        backendGetRequest("/api/bank-account/all/", { params: { ...baseParams, ...{ page_index: 0 } } })
            .then((res) => {
                setAccountsPageCountExpected(prevState => res?.data?.total_pages);
                for (let i = 1; i <= res?.data?.total_pages; i++) {
                    let params = { ...baseParams, ...{ page_index: i } }
                    backendGetRequestWithCache("/api/bank-account/all/", { params: params },
                        (cachedResponse) => {
                            if (cachedResponse?.data) {
                                setAccountsPerPage(prevState => {
                                    if (!prevState[params.page_index]) {
                                        return {
                                            ...prevState,
                                            [params.page_index]: cachedResponse?.data?.bank_accounts,
                                        }
                                    }
                                    return prevState;
                                });
                            }
                        },
                        (nonCachedResponse) => {
                            if (nonCachedResponse?.data) {
                                setAccountsPerPage(prevState => ({
                                    ...prevState,
                                    [params.page_index]: nonCachedResponse?.data?.bank_accounts,
                                }));
                                setAccountsPageCountReceived(prevState => prevState === -1 ? 1 : prevState + 1);
                            }
                        },
                        () => { // error handling
                            setAccountsPageCountExpected(prevState => prevState - 1);
                        }
                    );
                }
            })

    }

    useEffect(() => {
        getBankAccounts()

        const fetchCustomHierarchy = async () => {
            try {
                const res = await backendGetRequest("/api/generic-tag/", { params: { 'page_index': 0, group_type: BA_TAG } });
                setCustomHierarchyPageCount(res.data?.total_pages);
                setCustomHierarchyRecordsCount(res.data?.total_records);

                if (res.data.total_pages < 1) {
                    setLoadingCustomHierarchy(false);
                }

                for (let i = 1; i <= res.data?.total_pages; i++) {
                    try {
                        const resPage = await backendGetRequest("/api/generic-tag/", { params: { 'page_index': i, group_type: BA_TAG } });
                        if (resPage.data) {
                            setCustomHierarchy(prevData => [...prevData, ...resPage.data?.generic_tags]);
                        }
                    } catch (error) {
                        console.error(`Error fetching page ${i}:`, error);
                    }
                }
                setLoadingCustomHierarchy(false);
            } catch (error) {
                console.error('Error fetching custom hierarchy:', error);
            }
        };

        const fetchCustomCategories = async () => {
            try {
                const res = await backendGetRequest("/api/generic-tag/", { params: { 'page_index': 0, group_type: TXN_TAG } });
                setCustomCategoriesPageCount(res.data?.total_pages);
                setCustomCategoriesRecordsCount(res.data?.total_records);

                if (res.data.total_pages < 1) {
                    setLoadingCustomCategories(false);
                }

                for (let i = 1; i <= res.data?.total_pages; i++) {
                    try {
                        const resPage = await backendGetRequest("/api/generic-tag/", { params: { 'page_index': i, group_type: TXN_TAG } });
                        if (resPage.data) {
                            setCustomeCategories(prevData => [...prevData, ...resPage.data?.generic_tags]);
                        }
                    } catch (error) {
                        console.error(`Error fetching page ${i}:`, error);
                    }
                }
                setLoadingCustomCategories(false);
            } catch (error) {
                console.error('Error fetching custom categories:', error);
            }
        };

        const fetchAllInitialTransactions = async () => {
            await onLoadTransactions({ month: currentMonth, year: currentYear })
            await onLoadTransactions(decrementMonth(currentMonth, currentYear));
        }

        fetchCustomHierarchy();
        fetchCustomCategories();
        fetchAllInitialTransactions();
    }, []);

    const decrementMonth = (month, year, decrementInplace = false) => {
        if (month === 1) {
            month = 12;
            year -= 1;
        } else {
            month -= 1;
        }
        if (decrementInplace) {
            setCurrentMonth(month);
            setCurrentYear(year);
        }
        return { month: month, year: year };
    }

    const onLoadTransactions = async ({ month, year }) => {
        try {
            setTransactionsLoading(true);
            decrementMonth(month, year, true);
            const allTransactionsURL = "/api/transactions/all";
            const res = await backendGetRequest(allTransactionsURL, { params: { 'page_index': 0, month: month, year: year } });
            setTotalRecordsTransactions(res?.data?.total_records);
            setNonCachedPagesTotal(prev => prev + (res?.data?.total_pages || 0))

            // Function to handle sequential fetching for cached pages
            const fetchCachedPages = async () => {
                for (let i = 1; i <= res?.data?.total_pages; i++) {
                    try {
                        const cachedPageResponse = await backendGetCached(allTransactionsURL, { params: { 'page_index': i, month: month, year: year } });
                        if (cachedPageResponse.data) {
                            setTransactionDataRaw(prevState => {
                                let newTransactions = cachedPageResponse.data?.all_transactions?.filter(transaction =>
                                    !prevState.some(txn => txn.id === transaction.id)
                                );
                                return [...prevState, ...newTransactions];
                            });
                        }
                    } catch (error) {
                        console.error(`Error fetching cached page ${i}:`, error);
                    }
                }
            };

            // // Function to handle sequential fetching for non-cached pages
            const fetchNonCachedPages = async () => {
                for (let i = 1; i <= res.data?.total_pages; i++) {
                    try {
                        const nonCachedPageResponse = await backendGetRequest(allTransactionsURL, { params: { 'page_index': i, month: month, year: year } });
                        if (nonCachedPageResponse.data) {
                            setTransactionDataRaw(prevState => {
                                let newTransactions = [...prevState];
                                nonCachedPageResponse.data?.all_transactions?.forEach(transaction => {
                                    const existingTransactionIndex = newTransactions.findIndex(txn => txn.id === transaction.id);
                                    if (existingTransactionIndex !== -1) {
                                        newTransactions[existingTransactionIndex] = transaction;
                                    } else {
                                        newTransactions.push(transaction);
                                    }
                                });
                                return newTransactions;
                            });
                            backendUpdateCache(allTransactionsURL, { params: { 'page_index': i, month: month, year: year } }, nonCachedPageResponse.data);

                        }
                    } catch (error) {
                        console.error(`Error fetching non-cached page ${i}:`, error);
                    }
                    setNonCachedPagesTotalRetrieved(prev => prev + 1)
                }
            };

            // Run both functions in parallel
            await Promise.allSettled([fetchCachedPages(), fetchNonCachedPages()]);
            setTransactionsLoading(false);
        } catch (error) {
            console.error('Error fetching all transactions:', error);
        }
    };

    useEffect(() => {
        if (accountsLoading) {
            return
        }
        const refreshTransactions = async () => {
            try {
                setRefreshCallsTotal(Object.keys(allAccounts).length)
                const promises = Object.entries(allAccounts).map(([key, value]) =>
                    backendGetRequest("/api/transactions/refresh", {
                        params: { bank_account_id: parseInt(value.id) }
                    })
                        .then(res => {
                            if (res.data) {
                                setTransactionDataRaw(prevData => [...prevData, ...res?.data?.new_transactions]);
                            }

                            setRefreshCallsTotalRetrieved(prev => prev + 1)
                        })
                        .catch(error => {
                            console.error('Error refreshing transactions for account', value.id, ':', error);
                            setRefreshCallsTotal(prev => prev - 1)
                        })
                );
                const results = await Promise.allSettled(promises);
                setLoadingRefresh(false);
            } catch (error) {
                console.error('Error refreshing transactions:', error);
                setLoadingRefresh(false);
            }
        };
        if (Object.keys(allAccounts).length > 0) {
            refreshTransactions();
        }
    }, [allAccounts, accountsLoading]);


    const updateTransaction = (transactionId, updatedTransaction) => {
        setTransactionDataRaw((prevState) => {
            const updatedTransactions = prevState?.map((txn) => {
                if (txn.id === transactionId) {
                    return { ...txn, ...updatedTransaction };
                } else {
                    return txn;
                }
            });
            return updatedTransactions
        })
    }


    const updateTransactions = (newTransactions, originalTxnId) => {
        setTransactionDataRaw((prevState) => {
            const updatedCompleteTxns = prevState?.map((txn) => {
                if (txn.id === originalTxnId) {
                    return { ...txn, is_edited: true };
                }
                return txn;
            });
            return [...updatedCompleteTxns, ...newTransactions]
        })
    };

    return (
        <OuterBox>
            <TransactionsHome
                transactionData={transactionDataRaw}
                allAccounts={allAccounts}
                generalLedgerAccount={generalLedgerAccount}
                generalLedgerHeader={generalLedgerHeader}
                recordsCount={totalRecordsTransactions}
                customCategories={customCategories}
                customHierarchy={customHierarchy}
                loadingTable={(transactionsLoading)}
                updateTransactions={updateTransactions}
                updateTransaction={updateTransaction}
                progressNumerator={nonCachedPagesTotalRetrieved + refreshCallsTotalRetrieved}
                progressDenominator={nonCachedPagesTotal + refreshCallsTotal}
                //transactionDataRaw.length >= totalRecordsTransactions
                onLoadTransactions={onLoadTransactions}
                transactionsLoading={(transactionsLoading)}
                currentMonth={currentMonth}
                currentYear={currentYear}
                pending={false}
            />
        </OuterBox>
    );
}

export default Transactions;
